/**
 * The code shown on a wide screen leads to this same page on the phone, where the receipt is. The
 * link carries a mark, so the phone knows why it was opened and scrolls straight to the upload zone
 * instead of leaving the client at the top of a long screen.
 *
 * It only scrolls: a browser opens the file dialog in answer to a tap and never on page load.
 */
const ENTRY_PARAM = 'receipt';

export const receiptEntryUrl = (href: string = window.location.href): string => {
  try {
    const url = new URL(href);
    url.searchParams.set(ENTRY_PARAM, '1');
    return url.toString();
  } catch {
    return href;
  }
};

export const cameForReceipt = (search: string = window.location.search): boolean => {
  try {
    return new URLSearchParams(search).get(ENTRY_PARAM) === '1';
  } catch {
    return false;
  }
};
